(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
      this.onResizeHandler = this.onResize.bind(this);
      this.sectionHeader = null;
      this.stickyTrigger = 0;
    }

    connectedCallback() {
      // The section wrapper has class="section-header" from schema
      this.sectionHeader = document.querySelector('.section-header');
      if (!this.sectionHeader) return;

      this.setHeights();
      this.setTrigger();

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.addEventListener('resize', this.onResizeHandler);

      // run once
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    onResize() {
      this.setHeights();
      this.setTrigger();
      this.onScroll();
    }

    setTrigger() {
      // Trigger after scrolling past the header's bottom edge
      // Add a small buffer to prevent cutting off on first scroll
      if (this.sectionHeader) {
        const headerTop = this.sectionHeader.offsetTop;
        const headerHeight = this.sectionHeader.offsetHeight;
        // Add small buffer (10px) to ensure header is fully scrolled past before sticking
        this.stickyTrigger = headerTop + headerHeight + 10;
      } else {
        this.stickyTrigger = 0;
      }
    }

    setHeights() {
      const headerHeight = this.sectionHeader ? this.sectionHeader.offsetHeight : 0;
      document.documentElement.style.setProperty('--sticky-header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--hero-header-offset', `${headerHeight}px`);

      const announcement =
        document.querySelector('.shopify-section--announcement') ||
        document.querySelector('.announcement-bar') ||
        document.querySelector('.announcement') ||
        document.querySelector('[id*="_announcement"]');

      const announcementHeight = announcement ? announcement.offsetHeight : 0;
      document.documentElement.style.setProperty('--header-offset', `${announcementHeight}px`);
    }

    onScroll() {
      if (!this.sectionHeader) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldStick = scrollTop > this.stickyTrigger;

      if (shouldStick) {
        this.sectionHeader.classList.add('shopify-section-header-sticky', 'is-sticky');
        document.body.classList.add('header-fixed-padding');
      } else {
        this.sectionHeader.classList.remove('shopify-section-header-sticky', 'is-sticky');
        document.body.classList.remove('header-fixed-padding');
      }
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  function getBrightnessFromRGB(rgbString) {
    const rgb = rgbString.match(/\d+/g);
    if (!rgb || rgb.length < 3) return 255;
    const [r, g, b] = rgb.map(Number);
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  function updateNavHeight() {
    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;
    document.documentElement.style.setProperty('--nav-height', `${sectionHeader.offsetHeight}px`);
    document.documentElement.style.setProperty('--sticky-header-height', `${sectionHeader.offsetHeight}px`);
  }

  function updateLogoBasedOnBrightness(isDark) {
    const desktopLogo = document.querySelector('.header__heading-logo.desktop-and-tablet-only');
    const mobileLogo = document.querySelector('.header__heading-logo.small-mobile-only');

    const swapLogo = (imgEl, defaultKey, darkKey) => {
      if (!imgEl) return;
      const defaultSrc = imgEl.dataset[defaultKey];
      const darkSrc = imgEl.dataset[darkKey];
      const nextSrc = isDark && darkSrc ? darkSrc : defaultSrc;

      if (nextSrc && imgEl.src !== nextSrc) {
        imgEl.addEventListener('load', updateNavHeight, { once: true });
        imgEl.src = nextSrc;
      } else {
        updateNavHeight();
      }
    };

    swapLogo(desktopLogo, 'defaultLogo', 'darkLogo');
    swapLogo(mobileLogo, 'defaultLogo', 'darkLogo');
  }

  function updateMatchBanner() {
    const collectionHero = document.querySelector(".collection-hero");
    const articleHero = document.querySelector(".article-hero");
    const pageWithHeader = document.querySelector(".page-with-header");
    const firstBanner = document.querySelector(".shopify-section:first-of-type:has(.banner-full-width) .banner");
    const matchBanner = document.querySelector(".match-banner-style");
    const sectionHeader = document.querySelector(".section-header");

    if (!matchBanner || !sectionHeader) {
      updateNavHeight();
      return;
    }

    const pickColorClass = (el) => {
      if (!el) return null;
      const classes = Array.from(el.classList);
      return classes.find(cls => cls.startsWith("color-")) || null;
    };

    let colorClass = pickColorClass(articleHero)
      || pickColorClass(collectionHero)
      || pickColorClass(pageWithHeader)
      || pickColorClass(firstBanner);

    if (!matchBanner.dataset.originalColor) {
      const original = Array.from(matchBanner.classList).find(cls => cls.startsWith("color-"));
      if (original) matchBanner.dataset.originalColor = original;
    }

    // Apply matched color (if found)
    if (colorClass) {
      Array.from(matchBanner.classList).forEach(cls => {
        if (cls.startsWith("color-")) matchBanner.classList.remove(cls);
      });
      matchBanner.classList.add(colorClass);
      matchBanner.classList.add("match-banner-style--true");
    } else {
      matchBanner.classList.remove("match-banner-style--true");
      const originalColor = matchBanner.dataset.originalColor;
      if (originalColor) {
        Array.from(matchBanner.classList).forEach(cls => {
          if (cls.startsWith("color-")) matchBanner.classList.remove(cls);
        });
        matchBanner.classList.add(originalColor);
      }
    }

    // Brightness-based logo swap
    const bgSourceEl = collectionHero || articleHero || pageWithHeader || firstBanner;
    if (bgSourceEl) {
      const bgColor = getComputedStyle(bgSourceEl).backgroundColor;
      const br = getBrightnessFromRGB(bgColor);
      updateLogoBasedOnBrightness(br < 100);
    } else {
      updateNavHeight();
    }

    // keep css vars updated
    updateNavHeight();
  }

  document.addEventListener("DOMContentLoaded", updateMatchBanner);
  window.addEventListener("resize", updateMatchBanner);
  window.addEventListener("orientationchange", updateMatchBanner);

  function delayedUpdateMatchBanner() {
    setTimeout(updateMatchBanner, 0);
  }
  document.addEventListener("shopify:section:load", delayedUpdateMatchBanner);
  document.addEventListener("shopify:section:unload", delayedUpdateMatchBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
